import { Route } from 'vue-router';
import store from '@/vuex/store';

export default function authGuard(to: Route, from: Route, next: any) {
    if ((store.state as any).authorization.accessToken) {
        next();
    } else {
        next({ name: '403' });
    }
}